var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLawndoctorsIllustrationsFreeinstantpriceYardBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "136 257 331 245",
    enableBackground: "new 136 257 331 245",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_147_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_187_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E0BFA9",
    d: "M170.7,441.9c10.8,9.9,6.5,9.6-2.4,20.4c-6.9,8.5-3,23.6,51.9,27.7s156.2,8.4,189-8s11.1-35.6,31.9-41.4 s22.7-18.2-19.3-27.7c-42-9.6-220.2,0-220.2,0S142.3,415.9,170.7,441.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EA96",
    d: "M319.3,426.6h-85.2c-44.4,0-57.5,19.5-59.8,18.9c-3.3-0.9-10.9-7.6-12.2-12.8s-0.3-11.1,20.5-17.4 l20.8-6.3l66-5.3l46.4,3.2c0.2,0,0.3,0,0.5,0l15.1,1.8L319.3,426.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M422,412.9c-15.9-3.6-51.3-4.5-89.1-4.2l-1.3,1.3l-62,82.6l0.1,0.3c52.9,2.1,115.3,1.3,139.7-10.8 c32.8-16.3,11.1-35.6,31.9-41.4C462.1,434.8,464,422.4,422,412.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_186_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_206_",
    fill: "#6A7269",
    d: "M310.7,493.9c-39.1,0-77.6-2.4-95.6-3.9c-32.7-2.4-45.7-10.5-46.9-16.6 c-0.1-0.7-0.2-1.5-0.1-2.3c0.3-3.7,3-7,5.1-9.2c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7c-2,2-4.5,5.2-4.8,8.6 c-0.1,0.7,0,1.3,0.1,2c1.1,5.8,13.9,13.4,45.9,15.8c36.3,2.8,157.8,10.2,195.2-8.1c18.6-9.1,19.8-19.1,20.8-27.1 c0.8-6.6,1.5-12.3,11.4-15.1c9.6-2.7,15-6.4,14.9-10.4c-0.1-3.5-4.6-10.3-33.8-16.8c-42.5-9.5-223.4-0.2-227.5,0 c-1,0.3-17.2,4.8-29.5,10.4c-0.3,0.1-0.5,0-0.7-0.2c-0.1-0.3,0-0.5,0.2-0.7c12.6-5.8,29.5-10.5,29.7-10.5h0.1 c0.5,0,46.6-2.4,97.6-3.7c47-1.1,107.8-1.3,130.3,3.7c28.4,6.3,34.5,13.2,34.6,17.7c0.1,4.5-5.4,8.6-15.6,11.4 c-9.3,2.5-9.9,7.8-10.7,14.2c-1,8.3-2.2,18.6-21.3,27.8C391.8,491.3,351,493.9,310.7,493.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_185_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_205_",
    fill: "#6A7269",
    d: "M177.1,459.4c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7c2.2-1.5,3.3-3.5,3-5.6 c-0.5-3.3-3.8-6.2-8.8-7.9c-0.3-0.1-0.4-0.4-0.3-0.6c0.1-0.3,0.4-0.4,0.6-0.3c5.3,1.7,9,5.1,9.5,8.7c0.4,2.6-0.8,4.9-3.4,6.6 C177.3,459.4,177.2,459.4,177.1,459.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_177_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_204_",
    fill: "#6A7269",
    d: "M313.1,426.6H174.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h138.7c0.3,0,0.5,0.2,0.5,0.5 S313.4,426.6,313.1,426.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_178_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_190_",
    fill: "#6A7269",
    d: "M305,436.8H180.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5H305 c0.3,0,0.5,0.2,0.5,0.5C305.5,436.6,305.3,436.8,305,436.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_179_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_189_",
    fill: "#6A7269",
    d: "M289.7,449h-100c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h100c0.3,0,0.5,0.2,0.5,0.5 S290,449,289.7,449z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_180_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_188_",
    fill: "#6A7269",
    d: "M282.5,462.3h-95.9c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h95.9 c0.3,0,0.5,0.2,0.5,0.5C283,462.1,282.8,462.3,282.5,462.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_181_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_184_",
    fill: "#6A7269",
    d: "M266.2,478.6h-79.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h79.6 c0.3,0,0.5,0.2,0.5,0.5C266.7,478.4,266.5,478.6,266.2,478.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_11_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9F9",
    d: "M339.1,425.6c0,0-22,31.1-27.8,41c-5.9,9.9,1,15.2,30.4,13.7c29.4-1.5,61.7-8.7,67.2-28.1 c4.7-16.5-12.8-24-12.8-24s-21.4,9.6-33.3-2.7H339.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_183_",
    fill: "#6A7269",
    d: "M269.5,493.1c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.3-0.5-0.1-0.7l62-82.6 c0.2-0.2,0.5-0.3,0.7-0.1c0.2,0.2,0.3,0.5,0.1,0.7l-62,82.6C269.8,493,269.7,493.1,269.5,493.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5FB4CE",
    d: "M397.7,466.5c-1-0.4-1.6-0.6-1.6-0.6s-25.2,12.5-34.7-3.6h-21.2c0,0-5.1,8.5-11.1,18.6 c3.9,0,8.1-0.3,12.6-0.6C362.4,479.2,384.4,475.4,397.7,466.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    fill: "#7DCBEA",
    d: "M408.9,452.2c0.2-0.6,0.3-1.3,0.4-1.9c-3.8-11.8-13.4-14-13.4-14s-25.2,12.5-34.7-3.6 h-21.2c0,0-19.5,32.5-27,45.4c7.1,3.8,16.6,2.9,28.6,2.2C371.1,478.7,403.4,471.7,408.9,452.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    fill: "#6A7269",
    d: "M332.6,481c-14.4,0-23.1-2.1-25.6-6.5c-1.3-2.2-1.1-5.1,0.8-8.3 c5.8-9.8,29.7-43,29.9-43.4c0.1-0.1,0.2-0.2,0.4-0.2h24.8c0.1,0,0.3,0.1,0.4,0.2c11.4,11.8,33.5,2.9,33.7,2.8c0.1-0.1,0.3,0,0.4,0 s2.2,1.2,5,3.5c0.2,0.2,0.2,0.5,0.1,0.7c-0.2,0.2-0.5,0.2-0.7,0.1c-2.1-1.7-4-2.9-4.6-3.2c-2.4,0.9-23.2,8.5-34.5-3h-24.4 c-2,2.9-24.2,33.8-29.7,43c-1.7,2.9-2,5.3-0.8,7.2c2,3.4,9.5,7,33.9,5.8c16.5-0.8,56.2-4.8,66.9-23.2c0.3-0.4,0.5-0.9,0.7-1.3 c0.5-1,0.9-2.1,1.2-3.2c1.2-4.4,0.9-8.7-0.9-12.8c-0.1-0.3,0-0.5,0.2-0.7c0.2-0.1,0.5,0,0.7,0.2c1.9,4.3,2.3,8.9,1,13.5 c-0.3,1.1-0.7,2.2-1.2,3.4c-0.2,0.5-0.5,0.9-0.7,1.4c-4.5,7.8-19.3,21.1-67.7,23.7C338.4,480.9,335.4,481,332.6,481z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_150_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_203_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A7269",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M201,433.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_201_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E0BFA9",
    d: "M158.1,448c-0.7,2-1.7,5.9-1.3,8.3c1.3,6.9,6.9,11.3,17.7,9.9l34.1-32.6c0,0,4-2.5,2.1-7.9 c-1.8-5.3-9-5.2-11.9-3.6c-2.6,1.4-30.2,16.5-37.4,20.5c-1.1,0.6-2,1.6-2.4,2.9C158.7,446.4,158.3,447.5,158.1,448z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_199_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EA96",
    d: "M210.4,432.1l-32.3,27.5c0,0-1.3,0.2-1.4-0.5c-0.1-0.7-0.7,1.7-3.7,2.7c-3,0.9-9.1,0.7-10.9-2.7 c-1.8-3.4-2.2-8.4,2.9-9.7c5-1.4,7,1.8,7.5,3.8c0,0,0.5,3.3-0.9,4.2c0,0-1.8,0.1-3.1-0.5s-4-0.6-4-0.6s1.4,3.8,5.4,3.4 c4-0.4,5.9-2.8,5.7-6c-0.1-3.3-4.9-7.3-9.6-6.8c-4.7,0.5-7.4,3.3-7.2,7s1.5,8.2,5.9,9.5c4.5,1.3,1.8,1.8,11.1,0.5 C182.5,462.9,210.4,432.1,210.4,432.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_196_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_197_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M164.1,441.8c0.1,0,0.1,0,0.2-0.1l35.3-19.4c0.2-0.1,0.3-0.4,0.2-0.6s-0.4-0.3-0.6-0.2l-35.3,19.4 c-0.2,0.1-0.3,0.4-0.2,0.6C163.7,441.7,163.9,441.8,164.1,441.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_194_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_195_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M177.7,460c0.2,0,0.4-0.1,0.6-0.3l32-27.1c0.1-0.1,3-3.1,0.7-7.8c-1.9-4.2-6-3.8-6-3.8l0,0 c-0.3,0-0.4,0.3-0.4,0.5c0,0.3,0.3,0.4,0.5,0.4c0.1,0,3.4-0.4,5.1,3.2c1.9,4.2-0.5,6.6-0.5,6.7l-32,27c-0.1,0.1-0.2,0-0.3,0 c0,0-0.2-0.1-0.1-0.3c0.5-1.6,0.6-3.4,0.4-5.2c-0.6-4.7-3.7-8.2-8-9.1c-0.3-0.1-0.5,0.1-0.5,0.4c-0.1,0.3,0.1,0.5,0.4,0.5 c3.9,0.8,6.6,3.9,7.1,8.3c0.2,1.6,0.1,3.3-0.3,4.8c-0.2,0.5,0,1.1,0.5,1.4C177.1,460,177.4,460,177.7,460z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_192_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_193_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M184.7,458.6c0.3,0,0.4-0.3,0.4-0.5c0-0.3-0.3-0.4-0.5-0.4l-10.1,8.1c-9.7,1.3-15.8-2-17.2-9.5 c-0.4-2.1,0.4-6.1,1.3-8c0.1-0.2,0-0.5-0.2-0.6c-0.2-0.1-0.5,0-0.6,0.2c-1,1.9-1.8,6.1-1.4,8.6c1.5,7.9,8.2,11.6,18.4,10.3 L184.7,458.6L184.7,458.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_165_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M209.1,432.9c0.3,0,0.4-0.3,0.4-0.5c0-0.3,0.7-0.6,0.4-0.5l0.5-0.1c-0.3,0-0.4,0.3-0.4,0.5 c0,0.3-0.7,0.6-0.4,0.5L209.1,432.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_163_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M170.8,462.7c4.3-0.6,6.3-3.9,6.4-3.9c0.1-0.2,0.1-0.5-0.2-0.6c-0.2-0.1-0.5-0.1-0.6,0.2 c-0.1,0.2-3.3,5.1-10.1,3.1c-1.6-0.5-6.8-2.7-5.1-9.3c0.1-0.2-0.1-0.5-0.3-0.6c-0.2-0.1-0.5,0.1-0.6,0.3 c-1.5,5.9,1.9,9.3,5.7,10.4C167.9,462.7,169.5,462.8,170.8,462.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_161_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M170.5,458c0.2,0,0.4-0.1,0.7-0.2c0.6-0.2,1.1-0.8,1.4-1.5c0.5-1.2,0.4-2.9-0.2-4.4 c-1.5-3.5-5.4-3.5-5.6-3.5c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5c0.1,0,3.5,0,4.7,3c0.5,1.3,0.6,2.6,0.2,3.6 c-0.2,0.5-0.5,0.9-0.8,1c-1.2,0.5-2.7-0.7-2.7-0.7c-0.2-0.2-0.5-0.2-0.7,0s-0.2,0.5,0,0.7C167.7,457,169,458.2,170.5,458z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_159_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_160_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M159.8,446L159.8,446c0.3,0,0.6-0.3,0.5-0.6c0-0.1-0.3-1.9-1.8-3.1c-0.3-0.2-0.7-0.1-0.9,0.1 c-0.2,0.3-0.2,0.7,0.1,0.9c1.1,0.8,1.3,2.2,1.3,2.2C159.1,445.9,159.4,446,159.8,446z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_157_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M161.9,446.7c0.1,0,0.2,0,0.2-0.1c0.3-0.2,0.4-0.5,0.2-0.8c0-0.1-0.6-1.2,0.4-4.4 c0.1-0.3-0.1-0.7-0.4-0.8c-0.3-0.1-0.7,0.1-0.8,0.4c-1.2,3.8-0.4,5.2-0.3,5.4C161.5,446.6,161.7,446.7,161.9,446.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_153_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_154_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M200.7,422.2L200.7,422.2c0.3,0,0.4-0.3,0.4-0.6c0-0.1-0.3-1.4-1.3-2.3c-0.2-0.2-0.5-0.1-0.7,0.1 c-0.2,0.2-0.1,0.5,0.1,0.7c0.8,0.6,1,1.7,1,1.7C200.3,422.1,200.5,422.3,200.7,422.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_151_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_152_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M202.8,422.2c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.3-0.4,0.2-0.6c0,0-0.4-0.8,0.3-2.9c0.1-0.2-0.1-0.5-0.3-0.6 c-0.2-0.1-0.5,0.1-0.6,0.3c-0.8,2.5-0.3,3.6-0.2,3.7C202.4,422.2,202.6,422.2,202.8,422.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_167_"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 213.8,
    y1: 431.9,
    x2: 213.8,
    y2: 431.9
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    fill: "#6A7269",
    d: "M400.8,459.2c-0.3,0-0.5-0.3-0.5-0.6c0-0.5-0.1-13.4,0.2-14.8c0.3-1.6,9.6-11.3,13.1-10.7 c0.9,0.2,1.6,0.6,2.1,1.3c0.8,1.3,0.5,3.1,0.5,3.5v6c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-6.1v-0.1c0,0,0.4-1.6-0.3-2.8 c-0.3-0.5-0.8-0.7-1.4-0.8c-1.1-0.2-3.7,1.4-6.8,4.3c-2.9,2.7-5,5.1-5.1,5.6c-0.2,1.1-0.2,10.9-0.2,14.6 C401.3,458.9,401.1,459.2,400.8,459.2L400.8,459.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    fill: "#6A7269",
    d: "M397.7,448c-0.3,0-0.5-0.3-0.5-0.6s-0.1-8.3,0.2-9.7c0.3-1.6,8.6-11.3,12-10.7 c0.9,0.2,1.6,0.6,2.1,1.3c0.8,1.3,0.5,3.1,0.5,3.5v6c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5v-6.1v-0.1c0,0,0.4-1.6-0.3-2.8 c-0.3-0.5-0.8-0.7-1.4-0.8c-1.1-0.2-3.6,1.4-6.3,4.3c-2.7,2.7-4.5,5.2-4.6,5.6c-0.2,1.1-0.2,7.2-0.2,9.5 C398.2,447.7,398,448,397.7,448L397.7,448z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_145_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_146_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E6E7E8",
    points: "186.9,360.3 182.4,360.3 229.2,313.6 275.7,360.3 265.4,360.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_143_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_144_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DCE6EA",
    points: "268.3,358.6 227.8,318.2 186.7,358.6 186.7,420.5 268.3,420.5  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_141_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_142_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DCE6EA",
    points: "268.3,411.9 423.3,412.8 423.3,359.7 267.8,359.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_139_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_140_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C2CFD3",
    points: "268.3,411.8 274.4,412 274.4,363.4 423.3,363.4 423.3,359.3 267.6,359.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_137_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_138_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "239.2,420.5 211.1,420.5 211.1,378.4 239.5,378.1  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_135_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_136_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.2,
    y: 380.7,
    fill: "#D3DADD",
    width: 26.5,
    height: 39.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_133_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_134_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 387.8,
    fill: "#E2E7E8",
    width: 8.3,
    height: 11.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_131_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_132_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.7,
    y: 406,
    fill: "#BAC4C6",
    width: 8.3,
    height: 11.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_130_"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 216.1,
    cy: 402.4,
    r: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_121_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_122_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.7,
    y: 371.5,
    fill: "#FFFFFF",
    width: 29.6,
    height: 27.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_119_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_120_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.7,
    y: 371.5,
    fill: "#C6EAF4",
    width: 28.6,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_117_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_118_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.5,
    y: 371.5,
    fill: "#FFFFFF",
    width: 29.6,
    height: 27.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_115_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_116_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.5,
    y: 371.5,
    fill: "#C6EAF4",
    width: 27.5,
    height: 25.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_113_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_114_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C2CFD3",
    points: "186.7,358.6 186.7,364 228,324.3 268.3,364.7 268.3,358.6 227.8,318.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_111_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_112_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#D3DADD",
    points: "242.1,321.5 418.4,321.5 430.3,359.3 279.8,359.3  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_109_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#DCE6EA",
    points: "386.6,318.5 399.8,318.5 399.8,304.2 402.9,304.2 402.9,299.1 383.5,299.1 383.5,304.2  386.6,304.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_107_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_108_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C2CFD3",
    points: "383.5,303.2 383.5,304.2 386.6,304.2 386.6,306.2 399.8,306.2 399.8,304.2 402.9,304.2  402.9,303.2  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_106_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M267.8,420.5h-81.6c-0.3,0-0.5-0.2-0.5-0.5v-61.4c0-0.1,0.1-0.3,0.1-0.4l40.9-40.5c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-40.7,40.4v60.7h80.6v-7.8c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.1l155.5,1.1v-53.6 c0-0.3,0.2-0.5,0.5-0.5h5.8l-12.5-39.8H233.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h183.8c0.2,0,0.4,0.1,0.5,0.3l13,40.8 c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2h-6v53.6c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.2,0.2-0.4,0.2l0,0l-155.5-1.1v7.8 C268.3,420.3,268.1,420.5,267.8,420.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_103_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_104_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M427.4,359.3H268.8c-0.1,0-0.3-0.1-0.4-0.1l-40.8-40.9c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0 l40.6,40.8h158.5c0.3,0,0.5,0.2,0.5,0.5S427.7,359.3,427.4,359.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_101_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_102_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M414.1,325.6H242.8c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h171.4c0.3,0,0.5,0.2,0.5,0.5 C414.6,325.4,414.4,325.6,414.1,325.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_100_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M418.2,337.9H253c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h165.2c0.3,0,0.5,0.2,0.5,0.5 S418.5,337.9,418.2,337.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_97_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M420.2,349.1H264.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h156.1c0.3,0,0.5,0.2,0.5,0.5 S420.5,349.1,420.2,349.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_81_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_82_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M372.8,399.1h-30.6c-0.3,0-0.5-0.2-0.5-0.5V371c0-0.3,0.2-0.5,0.5-0.5h30.6c0.3,0,0.5,0.2,0.5,0.5v27.5 C373.3,398.9,373.1,399.1,372.8,399.1z M342.7,398h29.6v-26.5h-29.6V398z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_79_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_80_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M353.4,398.5c-0.3,0-0.5-0.2-0.5-0.5v-24.5c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V398 C353.9,398.3,353.7,398.5,353.4,398.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_78_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M361.6,398.5c-0.3,0-0.5-0.2-0.5-0.5v-24.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5V398 C362.1,398.3,361.9,398.5,361.6,398.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_75_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_76_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M369.2,383.8h-21.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h21.4c0.3,0,0.5,0.2,0.5,0.5 S369.5,383.8,369.2,383.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_73_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_74_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M369.2,391.9h-21.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h21.4c0.3,0,0.5,0.2,0.5,0.5 S369.5,391.9,369.2,391.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_71_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_72_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M375.4,399.1h-36.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h36.7c0.3,0,0.5,0.2,0.5,0.5 S375.7,399.1,375.4,399.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_67_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_68_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M413.6,399.1H385c-0.3,0-0.5-0.2-0.5-0.5V371c0-0.3,0.2-0.5,0.5-0.5h28.6c0.3,0,0.5,0.2,0.5,0.5v27.5 C414.1,398.9,413.9,399.1,413.6,399.1z M385.6,398h27.5v-26.5h-27.5V398z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_65_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_66_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M394.2,398.5c-0.3,0-0.5-0.2-0.5-0.5v-24.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5V398 C394.7,398.3,394.5,398.5,394.2,398.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_64_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M403.4,398.5c-0.3,0-0.5-0.2-0.5-0.5v-24.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5V398 C403.9,398.3,403.7,398.5,403.4,398.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_61_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_62_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M410,383.8h-20.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H410c0.3,0,0.5,0.2,0.5,0.5 S410.3,383.8,410,383.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_59_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_60_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M410,391.9h-20.4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H410c0.3,0,0.5,0.2,0.5,0.5 S410.3,391.9,410,391.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_57_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_58_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M416.2,399.1h-35.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h35.7c0.3,0,0.5,0.2,0.5,0.5 S416.5,399.1,416.2,399.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M239.2,420.5h-27.5c-0.3,0-0.5-0.2-0.5-0.5v-41.8c0-0.3,0.2-0.5,0.5-0.5h27.5c0.3,0,0.5,0.2,0.5,0.5V420 C239.7,420.3,239.5,420.5,239.2,420.5z M212.2,419.5h26.5v-40.8h-26.5V419.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M216.1,404.7c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2s2.2,1,2.2,2.2C218.4,403.8,217.4,404.7,216.1,404.7z  M216.1,401.3c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2c0.7,0,1.2-0.5,1.2-1.2C217.4,401.8,216.8,401.3,216.1,401.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_43_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_44_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M230,399.9h-8.3c-0.3,0-0.5-0.2-0.5-0.5v-11.5c0-0.3,0.2-0.5,0.5-0.5h8.3c0.3,0,0.5,0.2,0.5,0.5v11.5 C230.5,399.7,230.3,399.9,230,399.9z M222.3,398.9h7.2v-10.5h-7.2V398.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_39_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M230,417.6h-8.3c-0.3,0-0.5-0.2-0.5-0.5V406c0-0.3,0.2-0.5,0.5-0.5h8.3c0.3,0,0.5,0.2,0.5,0.5v11.1 C230.5,417.3,230.3,417.6,230,417.6z M222.3,416.6h7.2v-10.1h-7.2V416.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M242.4,378.9h-33.9c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5h33.9c0.3,0,0.5,0.2,0.5,0.5v3 C242.9,378.7,242.7,378.9,242.4,378.9z M209,377.8h32.8v-1.9H209V377.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M398.8,318.7h-13.3c-0.3,0-0.5-0.2-0.5-0.5v-14.9c0-0.3,0.2-0.5,0.5-0.5h13.3c0.3,0,0.5,0.2,0.5,0.5v14.9 C399.3,318.5,399.1,318.7,398.8,318.7z M386.1,317.7h12.2v-13.9h-12.2V317.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M402.5,303.8h-20.7c-0.3,0-0.5-0.2-0.5-0.5v-5.7c0-0.3,0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5h-2.4v4.7H402v-4.7h-8.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.2c0.3,0,0.5,0.2,0.5,0.5v5.7 C403,303.5,402.8,303.8,402.5,303.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M391,298h-4.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h4.1c0.3,0,0.5,0.2,0.5,0.5 S391.2,298,391,298z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M185.6,359.3h-4.4c-0.2,0-0.4-0.1-0.5-0.3c-0.1-0.2,0-0.4,0.1-0.5l13.7-13.7c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-12.8,12.8h3.2c0.3,0,0.5,0.2,0.5,0.5S185.9,359.3,185.6,359.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M197.4,343.6c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l18.8-18.8c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-18.8,18.8C197.6,343.5,197.5,343.6,197.4,343.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M218.9,321.9c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l4.8-4.8c0.2-0.2,0.5-0.2,0.7,0 c0.2,0.2,0.2,0.5,0,0.7l-4.8,4.8C219.2,321.9,219.1,321.9,218.9,321.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M274.7,359.4c-0.1,0-0.3,0-0.4-0.1l-46.2-46.2l-1,1c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.2-0.2-0.5,0-0.7 l1.4-1.4c0.2-0.2,0.5-0.2,0.7,0l46.6,46.6c0.2,0.2,0.2,0.5,0,0.7C274.9,359.4,274.8,359.4,274.7,359.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A7269",
    d: "M267.8,420.5h-81.6c-0.3,0-0.5-0.2-0.5-0.5v-61.4c0-0.1,0.1-0.3,0.1-0.4l41.1-40.4c0.2-0.2,0.5-0.2,0.7,0 l40.5,40.4c0.1,0.1,0.1,0.2,0.1,0.4V420C268.3,420.3,268.1,420.5,267.8,420.5z M186.7,419.5h80.6v-60.7l-40-39.9l-40.6,39.9 V419.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M267.6,359.1"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    fill: "#6A7269",
    d: "M294.8,298.1H282c-0.2,0-0.4-0.1-0.4-0.3c-0.1-0.2-0.1-0.4,0-0.5c0.1-0.2,2.8-4,0-7 c-2.8-3.1-6.6-2.1-6.8-2.1c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.2-0.5-4-4.1-4s-4.4,4.2-4.4,4.4s-0.2,0.4-0.4,0.4 c-0.2,0-0.4-0.1-0.5-0.2c0-0.1-1.2-2-3.6-1.1c-2.4,1-2.8,5.3-2.8,5.4c0,0.3-0.2,0.5-0.5,0.5h-6.1c-0.3,0-0.5-0.2-0.5-0.5 s0.2-0.5,0.5-0.5h5.7c0.1-1.3,0.8-4.8,3.3-5.8c1.8-0.7,3.3-0.1,4.1,0.7c0.6-1.8,2.2-4.3,5.2-4.3c3.2,0,4.6,2.7,5,4.4 c1.3-0.2,4.7-0.3,7.2,2.6c2.4,2.8,1.2,6,0.5,7.5h11.9c0.3,0,0.5,0.2,0.5,0.5S295.1,298.1,294.8,298.1z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    fill: "#6A7269",
    d: "M343.7,277.7h-6.1c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h5.7 c0.1-1.3,0.8-4.8,3.3-5.8c1.8-0.7,3.3-0.1,4.1,0.7c0.6-1.9,2.2-4.4,5.2-4.4c3.3,0,4.6,2.7,5,4.4h8.4c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5h-8.8c-0.3,0-0.5-0.2-0.5-0.4s-0.5-3.9-4.1-3.9s-4.4,4.5-4.4,4.5c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.1-0.5-0.2 c0-0.1-1.2-2-3.6-1.1c-2.4,1-2.8,5.3-2.8,5.4C344.2,277.5,344,277.7,343.7,277.7z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_191_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EA96",
    d: "M152,371.1c-0.1-0.4-9.4,30.1-7.8,38.2c1.8,9.3,7.6,9.1,7.6,9.1h0.2c0,0,5.8,0.2,7.7-9.1 C161.4,401.2,152.1,370.7,152,371.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    fill: "#6A7269",
    d: "M151.5,446.5c-0.3,0-0.5-0.2-0.5-0.5v-58.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V446 C152,446.3,151.8,446.5,151.5,446.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M153.7,379.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    fill: "#6A7269",
    d: "M151,417.4c-0.4,0-6.2-0.2-8.2-9.6c-0.9-4.3,1.2-14.6,3.2-22.4c0-0.1,3.5-13.8,4.7-16.2 h-0.1c0.1-0.2,0.2-0.3,0.3-0.3l0,0h0.1h0.1l0,0c0.1,0,0.3,0.2,0.3,0.3h-0.1c1.2,2.4,4.7,16,4.7,16.2c1.9,7.9,4.1,18.1,3.2,22.4 C157.2,417.4,151.2,417.4,151,417.4L151,417.4L151,417.4z M151.1,370.9c-1.8,5.8-8.7,29.8-7.2,36.7c1.7,8.7,7,8.8,7.1,8.8l0,0h0.2 c0.3,0,5.4-0.1,7.1-8.8C159.7,400.7,152.9,376.7,151.1,370.9z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_148_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EA96",
    d: "M185.8,482.2c0,0,0.7-1.9,2.9-4.5c2.1-2.7,3.9-6.7,1.4-7.5c-2.4-0.8-7,4.7-7,4.7s-1.6-3.2-4.7-3 s-1.9,3.2-0.6,4.2c1.3,1,2.6,6.3,2.6,6.3L185.8,482.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_123_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_156_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EA96",
    d: "M174,361.6c-0.1-0.3-7.8,25.1-6.4,31.8c1.5,7.7,6.3,7.7,6.3,7.7h0.2c0,0,4.8,0,6.3-7.7 C181.8,386.7,174.1,361.3,174,361.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_155_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    fill: "#6A7269",
    d: "M172.9,424c-0.3,0-0.5-0.2-0.5-0.5v-39.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v39.8 C173.4,423.8,173.2,424,172.9,424z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_125_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M175.4,368.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_124_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    fill: "#6A7269",
    d: "M173.2,400.1c-0.3,0-5.2-0.1-6.8-8.1c-0.7-3.6,1-12.1,2.7-18.6c0-0.1,2.8-11.2,3.9-13.4 h-0.1c0.1-0.2,0.2-0.3,0.3-0.3l0,0h0.1c0.1,0,0.1,0,0.1,0l0,0c0.1,0,0.3,0.2,0.3,0.3h-0.1c1.1,2.1,3.9,13.3,3.9,13.4 c1.6,6.5,3.4,15,2.7,18.6C178.4,400,173.4,400.1,173.2,400.1L173.2,400.1L173.2,400.1z M173.3,361.7c-1.6,5.2-7,24.5-5.9,30.1 c1.4,7.1,5.6,7.2,5.8,7.2h0.2c0.2,0,4.4-0.1,5.8-7.2C180.3,386.2,174.9,366.9,173.3,361.7z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_126_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    fill: "#6A7269",
    d: "M183.1,483.4c-0.2,0-0.5-0.2-0.5-0.4c0-0.1-0.8-6.6-3.9-8.5c-0.2-0.1-0.3-0.5-0.2-0.7 s0.5-0.3,0.7-0.2c3.4,2.1,4.3,8.9,4.3,9.2C183.6,483.1,183.4,483.3,183.1,483.4L183.1,483.4z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_127_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    fill: "#6A7269",
    d: "M184.8,481.9c-0.2,0-0.4-0.2-0.5-0.4c0-0.2-1-5.7,4.4-10c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7c-5,4-4.1,8.9-4.1,9.1C185.3,481.6,185.1,481.9,184.8,481.9L184.8,481.9z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    fill: "#6A7269",
    d: "M299.4,419.2c-0.2,0-0.5-0.2-0.5-0.4c0-0.1-0.8-6.6-3.9-8.5c-0.2-0.1-0.3-0.5-0.2-0.7 c0.1-0.2,0.5-0.3,0.7-0.2c3.4,2.1,4.3,8.9,4.3,9.2C299.9,418.8,299.7,419.1,299.4,419.2L299.4,419.2z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_86_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    fill: "#6A7269",
    d: "M301.1,417.6c-0.2,0-0.4-0.2-0.5-0.4c0-0.2-1-5.7,4.4-10c0.2-0.2,0.5-0.1,0.7,0.1 s0.1,0.5-0.1,0.7c-5,4-4.1,8.9-4.1,9.1C301.6,417.3,301.4,417.6,301.1,417.6L301.1,417.6z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A7269",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M182.1,471.6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawndoctorsIllustrationsFreeinstantpriceYardBack);
export default __webpack_public_path__ + "static/media/lawndoctors-illustrations-freeinstantprice-yard-back.d17bf10a.svg";
export { ForwardRef as ReactComponent };